<template>
	<div class="relative flex flex-col gap-2">
		<div class="flex items-end gap-3">
			<LabeledObject full :required="required">
				<template #label>{{ trans(label) }}</template>
				<template #action>
					<slot name="action"/>
				</template>
				<input v-model="term" type="text" autocomplete="off" @keydown.enter.stop="search">
			</LabeledObject>
			<PrimaryButton :color="Color.Blue" @click.stop="search">
				<i class="fa-solid fa-search"/>
			</PrimaryButton>
		</div>
		<SearchResults v-if="results.length > 0 || isNotEmpty(morphResults)" :relative="relative">
			<template v-if="morph">
				<template v-for="(abstractItems, abstractTitle) in morphResults">
					<template v-if="abstractItems.length > 0">
						<SearchResultItem v-for="item in abstractItems" :relative="relative" @click.stop="select(item)">
							<p class="font-semibold">{{ item[attribute] }}</p>
							<p class="text-sm text-gray-400">{{ trans(`${abstractPrefix}${abstractTitle}.title`) }}</p>
						</SearchResultItem>
					</template>
				</template>
			</template>
			<template v-else>
				<SearchResultItem v-for="item in results" :relative="relative" @click.stop="select(item)">
					<p class="text-sm">{{ item[attribute] }}</p>
				</SearchResultItem>
			</template>
		</SearchResults>
	</div>
</template>
<script setup lang="ts">
import _ from 'lodash'
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import LabeledObject from '@/Components/LabeledObject.vue'
import {defineEmits, defineProps, type Ref, ref} from 'vue'
import SearchResults from '@/Components/Search/SearchResults.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/helpers'
import SearchResultItem from '@/Components/Search/SearchResultItem.vue'

const props = defineProps<{
	label:string,
	morph?:boolean,
	attribute:string,
	relative?:boolean,
	required?:boolean,
	searchType:string,
	additionalData?:object,
	abstractPrefix?:string,
}>()

const emit = defineEmits([
	'selected',
])

const term:Ref<string> = ref('')
const results:Ref<Array<object>> = ref([])
const morphResults:Ref<Array<Array<object>>> = ref([])
const label:Ref<string> = ref(props.label)
const morph:Ref<boolean> = ref(props.morph)
const searching:Ref<boolean> = ref(false)
const attribute:Ref<string> = ref(props.attribute)
const searchType:Ref<string> = ref(props.searchType)
const additionalData:Ref<object> = ref(props.additionalData ?? {})

function isNotEmpty(o:object):boolean{
	return !_.isEmpty(o)
}

function search(){
	if(!searching.value && term.value.length >= 3){
		searching.value = true
		showInfo(trans('general.searching'))
		axios.post(route('search.index', searchType.value), {
			term: term.value,
			...additionalData.value,
		}).then(({data}) => {
			showSuccess(trans('general.shown'))
			if(morph.value){
				morphResults.value = data.results
			} else {
				results.value = data.results
			}
		}).catch(showValidationErrors).finally(() => {
			searching.value = false
		})
	}
}

function select(item:any):void{
	if(morph.value){
		emit('selected', item.morpher, item)
	} else {
		emit('selected', item)
	}
	term.value = ''
	results.value = []
	morphResults.value = []
}
</script>